export const overlayUrl = {
  type: "string",
  minLength: 1,
  maxLength: 2_048
};
